import styled from 'styled-components';
export const StyledIconWrapper = styled.div.withConfig({
  displayName: "StyledIconWrapper",
  componentId: "sc-1ns5jkt-0"
})(["padding:0 !important;margin:0 !important;border:0 !important;background:none !important;width:14px;height:14px;display:flex;align-items:center;justify-content:center;pointer-events:none !important;"]);